<template>
  <VContainer
    class="privacy-policy-page-container pt-11"
    fluid
  >
    <SBackButton class="mb-6" />
    <SArticle
      :title="article.title"
      :subTitle="article.subTitle"
      :content="article.content"
    />
  </VContainer>
</template>

<script lang="ts">
export default {
  name: 'SPrivacyPolicy',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import StrapiService from '@slg/web-customer-shared/src/services/StrapiService';
import SArticle from '@slg/web-customer-shared/src/components/common/SArticle';
import SBackButton from '@slg/web-customer-shared/src/components/common/SBackButton';
import { useCmsLocaleReload } from '../../composables';

const pageData = ref<Record<string, any> | null>(null);

const article = computed(() => pageData.value?.article || {});

async function loadCmsData() {
  try {
    pageData.value = await StrapiService.getPrivacyPolicyPage();
  } catch (e) {
    // to-do rethink about catch
  }
}

useCmsLocaleReload(loadCmsData);
</script>

<style lang="scss">
.privacy-policy-page-container {
  margin: 0 auto;
  min-height: 400px;
}
</style>
